import styled from "styled-components"

export const HeroContainer = styled.div`
    width: 100%;
    background-color: ${(props) => props.bgColor };
`

export const TwoColumns = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;

    @media screen and (max-width: 480px){
        display: block;
    }
`
export const BoxLogos =styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    padding: 50px 0px;
    h4{
        font-size: 20px;
        font-weight: 700;
        color: #02391E;
    }
    img{
        width: 50%;
        margin: auto;
    }
    &.logos-financeiro-desktop{
        display: block;
    }
    &.logos-financeiro-mobile{
        display: none;
    }
    @media screen and (max-width: 480px){
        img{
            width: 95%;
            margin: auto;
        }
        &.logos-financeiro-desktop{
            display: none;
        }
        &.logos-financeiro-mobile{
            display: block;
        }
    }

`
export const BoxInfomation = styled.div`
    padding: 50px 50px 50px 0px;
    h3{
        font-size: ${(props) => props.sizeTitle };
        line-height: ${(props) => props.sizeTitle };
        color: ${(props) => props.colorTitle };
        font-weight: 700;
        margin: 0;
        margin: 30px 0px;
        @media screen and (max-width: 480px){
            display: block;
            margin: 10px 0px;
        }
    }
    p{
        font-size: 16px;
        color: ${(props) => props.colorText };
        font-weight: 400;
        z-index: 1;
    }
    &.heroheader{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: start;
        z-index: 1;
        h3{
            margin-top: 10px;
        }
        &:before{
            content: "";
            width: 305px;
            height: 165px;
            background: url("/placa-solar.png") no-repeat;
            position: absolute;
            bottom: -15px;
            left: -100px;
            z-index: 0;
            opacity: 0.5;
        }
    }
    @media screen and (max-width: 480px){
        text-align: center;
        padding: 0;
        margin: 15px 0px;
        &.financeiro{
            padding-top: 40px;
        }
    }
`
export const TransparentButton = styled.a`
  display: inline-block;
  color: ${(props) => props.textColor };
  border: 1px solid ${(props) => props.textColor };
  border-radius: 8px;
  padding: 10px 60px;
  margin-top: 20px;
  font-weight: 600;
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    background-color: ${(props) => props.textColor};
    color: ${(props) => props.hoverColor};
    transition: 0.3s;
  }
`

export const ContainerCA = styled.div`
    width: 100%;
    background-size: cover;
    padding: 60px 0px;
    text-align: center;
    p{
        font-size: 24px;
        color: #ffffff;
        text-align: center;
    }
    a{

    }
`
export const ContainerSE = styled.div`
    width: 100%;
    background-size: cover;
    padding: 60px 0px;
`
export const BoxServicos = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 15px;
    @media screen and (max-width: 480px){
        display: block;
        margin-top: 30px;
        div{
            margin-bottom: 20px;
        }
    }
`
export const Box = styled.div`
    text-align: center;
    border: 1px solid #ffffff;
    border-radius: 8px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    strong{
        color: #ffffff;
    }
`
export const ContentForm = styled.div`
    margin: 60px 0px;
    padding: 20px;
    background-color: #ffffff;
    box-shadow: 0px 1px 3px rgba(0,0,0,0.3);
    border-radius: 8px;
    position: relative;
    label{
        width: 46%;
        margin: 0px 2% 15px 2%;
        float: left;
        color: #575757;
        font-size: 14px;
        font-weight: 500;
        input[type=text]{
            width: 100%;
            height: 35px;
            border-radius: 4px;
            border: 1px solid #B6B6B6;
            color: #000000;
            margin-top: 5px;
            padding-left: 10px;
        }
        select{
            width: 105%;
            height: 40px;
            border-radius: 4px;
            margin-top: 5px;
            padding-left: 10px;
            border: 1px solid #B6B6B6;
            color: #000000;
        }
        input[type=checkbox]{
            margin-top: 35px;
        }
    }
    button{
        background: linear-gradient(102.17deg, #FED15D 3.82%, #FFC85E 49.63%, #FFDF8C 94.49%);
        border: 1px solid transparent;
        width: 96%;
        margin-left: 2%;
        margin-top: 15px;
        height: 40px;
        border-radius: 8px;
    }
    @media screen and (max-width: 480px) {
        label{
            width: 91%;
        }

        
    } 
      
`

export const SeparatorImage = styled.img`
  width: 100%;
  height: 400px; 
  display: block;
  @media screen and (max-width: 768px) {
  display: none;
`;

export const DifferentialsSection = styled.section`
  width: 100%;

  background-color: #ffffff;
`;

export const SectionTitle = styled.h2`
  color: #02391E;
  text-align: center;
  font-size: 32px;
  margin-bottom: 50px;
  font-weight: 700;
`;

export const DifferentialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); 
  gap: 30px;

  /* Media query para telas menores (tablets e celulares) */
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr); 
  }

  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr; 
  }
`;

export const DifferentialItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  
  img {
    height: 50px; 
    margin-bottom: 20px;
  }

  p {
    color: #02391E;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
    max-width: 200px; 
  }
`;

export const StepsSection = styled.section`
  position: relative;
  width: 100%;
  padding: 80px 0;
  background-image: url('/imagem-fundo-2.png'); 
  background-size: cover;
  background-position: center;
  background-attachment: fixed; 

 
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); 
  }
`;

export const StepsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  gap: 70px;
  text-align: center;


  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr; 
  }
`;

export const StepCard = styled.div`
  background-color: #02391E; 
  border-radius: 16px; 
  padding: 20px;
  color: #ffffff; 
position: relative;

  h3 {
    color: #FED15D; 
    font-size: 22px;
    margin-top: 0;
    margin-bottom: 15px;
    line-height: 1.3;
  }

  p {
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 0;
  }
`;

export const StepNumberIcon = styled.img`
  position: absolute; 
  top: 50%; 
  left: -75px; 
  transform: translateY(-50%);
  height: 80px; 


  @media screen and (max-width: 768px) {
   
    display: none;
  }
`;